"use client";

import type { HTMLAttributes } from "react";
import { Box, styled, type SxProps, type Theme } from "@mui/material";
import type { DraggableAttributes, DraggableSyntheticListeners } from "@dnd-kit/core";
import { GripVertical } from "lucide-react";

const Handle = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 36,
  height: 36,
  cursor: "grab",
  color: "var(--text-secondary, #9ca3af)",
  touchAction: "none",

  "&:active": {
    cursor: "grabbing",
  },
});

interface DragHandleProps {
  attributes: DraggableAttributes | HTMLAttributes<HTMLElement>;
  listeners: DraggableSyntheticListeners;
  sx?: SxProps<Theme>;
}

export default function DragHandle({ attributes, listeners, sx }: DragHandleProps) {
  return (
    <Handle
      sx={sx}
      {...attributes}
      {...listeners}
      onClick={(event) => event.stopPropagation()}
      aria-label="Drag to reorder"
    >
      <GripVertical size={16} />
    </Handle>
  );
}
